import { createContext } from "react";
import { notificationState } from "../states/notification.state";

const context = createContext(notificationState);

export default context;
